module.exports = __webpack_public_path__ + "static/Slider4-becefc6cbbe2ff85c0a403c6c4770d73.jpg";